module.exports = __webpack_public_path__ + "static/img/10.6f4ece5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/5/zh/10.png
// module id = oQuY
// module chunks = 0